import sharedEn from "@boark/shared/locale/en";

export default {
  title: "Boark",
  home: "Home",
  locale: {
    english: "English",
    swedish: "Swedish",
  },
  login: {
    title: "Login",
    email: "Email",
    password: "Password",
    submit: "Login",
    error: "Invalid credentials",
  },
  auth: {
    registerLink: "Create an account",
    resetPasswordLink: "Reset password",
    backToLogin: "Back to login",
    registerTitle: "Register",
    registerSubmit: "Create account",
    registerError: "Could not create account",
    registerSuccessTitle: "Check your email",
    registerSuccessBody:
      "We sent you an activation link. Activate your account before signing in.",
    associationName: "Association name",
    associationDomain: "Association domain",
    organizationNumber: "Organization number",
    activateTitle: "Activate account",
    activateLoading: "Activating your account...",
    activateSuccess: "Your account is active. You can sign in now.",
    activateError: "This activation link is invalid or has expired.",
    resetRequestTitle: "Reset password",
    resetRequestSubmit: "Send reset link",
    resetRequestSuccessTitle: "Check your email",
    resetRequestSuccessBody:
      "If an account exists for that email, we sent a reset link.",
    resetConfirmTitle: "Choose a new password",
    resetConfirmSubmit: "Update password",
    resetConfirmSuccess: "Your password has been updated.",
    resetError: "Could not reset password",
    inviteAcceptTitle: "Accept invitation",
    inviteAcceptSubmit: "Join association",
    inviteAcceptSuccess: "Your account is ready. You can sign in now.",
    inviteAcceptError: "This invitation link is invalid or has expired.",
    adminUsersTitle: "Members",
    memberTypeOwner: "Owner",
    memberTypeMember: "Member",
    membersEmpty: "No members yet.",
    adminUsersEmpty: "You do not own any associations yet.",
    associationLabel: "Association",
    inviteSubmit: "Send invitation",
    inviteSuccess: "Invitation sent.",
    inviteError: "Could not send invitation",
    controlStartMenu: "Start",
    controlStartTitle: "Choose an association",
    controlStartIntro:
      "Select an association you own to manage invitations, or create a new one.",
    controlStartOwnedHeading: "Your associations",
    controlStartCreateHeading: "Create a new association",
    controlStartCreateSubmit: "Create and continue",
    controlStartCreateError: "Could not create association",
    controlStartLoadError: "Could not load your associations.",
    controlStartChangeAssociation: "Choose another association",
    associationCreateTitle: "Create association",
    associationEditTitle: "Edit association",
    associationEditLink: "Edit",
    backToAssociationStart: "Back to associations",
    associationFormError: "Could not save association",
    adminUsersForAssociation: "Invitations are sent for",
  },
  logout: "Logout",
  send: {
    title: "Send",
    submit: "Send",
  },
  page: {
    updatedAt: "Updated at",
    edit: "Edit",
    cancel: "Cancel",
    save: "Save",
    noContent: "No content, please check again later",
    noContentInAlternative: "No content, please check the primary language",
    noRoles: "No roles to display",
    type: "Page type",
    typeContent: "Content",
    typeRoles: "Roles",
  },
  search: {
    title: 'Search results for "{query}"',
    found: "Found {count} results",
    noResults: "No results found",
  },
  admin: {
    admin: "Admin",
    register: "Register",
    contract: "Contracts",
    procurement: "Procurements",
    boardMeetings: "Board meetings",
    issues: "Issues",
    maintenance: "Maintenance",
    roles: "Roles",
    users: "Users",
  },
  property: {
    property: "Property",
    properties: "Properties",
    name: "Name",
    create: "Create property",
    parts: "Property parts",
    partsEmpty: "No property parts yet",
    addPart: "Add property part",
    error: "Failed to save property",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "property",
      },
    ],
  },
  propertyCode: {
    code: "Code",
    create: "Create property code",
    propertiesEmpty: "No properties attached",
    attachProperty: "Attach property",
    addProperty: "Add property",
    propertyCount: "Properties",
    error: "Failed to save property code",
    propertyError: "Failed to attach property",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "property code",
      },
    ],
  },
  propertyPart: {
    propertyPart: "Property part",
    propertyParts: "Property parts",
    code: "Code",
    name: "Name",
    create: "Create property part",
    propertiesEmpty: "No properties linked",
    linkedProperties: "Linked properties (optional)",
    attachProperty: "Attach property",
    addProperty: "Add property",
    propertyError: "Failed to attach property",
    error: "Failed to save property part",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "property part",
      },
    ],
  },
  maintenance: {
    planTab: "Plan",
    groupsTab: "Groups",
    propertiesTab: "Properties",
    propertyPartsTab: "Property parts",
    propertyCodesTab: "Property codes",
    propertyDeleteError:
      "This property cannot be deleted because it is used by maintenance plans",
    propertyPartDeleteError:
      "This property part cannot be deleted because it is used by maintenance plans",
    code: "Code",
    groupName: "Group name",
    codes: "Codes",
    codesEmpty: "No codes in this group yet",
    codePlaceholder: "New code",
    addCode: "Add code",
    description: "Description",
    cost: "Cost",
    yearlyFrequency: "Yearly frequency",
    createdAt: "Created",
    actions: "Actions",
    actionsEmpty: "No actions recorded yet",
    actionYear: "Year",
    actionMonth: "Month",
    actionAdd: "Add action",
    deleteAction: "Delete",
    lastAction: "Last action",
    requireAction: "Action required",
    nextAction: "Next action",
    nextActionTitle: "Next action",
    nextActionDue: "Next action due",
    nextActionNoInterval: "Set a yearly frequency on the plan to calculate the next action.",
    actionInCurrentYear: "An action is recorded for the current year.",
    nextActionOverdue: "The next action was due before the current year.",
    confirmDeleteAction: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "action",
      },
    ],
    propertyPart: "Property part",
    createPlan: "Create action",
    importPlan: "Import",
    importTitle: "Import maintenance plan",
    importPasteHelp:
      "Paste rows copied from a spreadsheet. Columns can be separated by tab, semicolon, or comma.",
    importPastePlaceholder: "Paste rows here…",
    importParse: "Parse",
    importMapHelp: "Map each column to a field, or choose Ignore to skip it.",
    importIgnoreColumn: "Ignore",
    importGroupCode: "Code",
    importGroupName: "Group name",
    importPropertyName: "Property name",
    importPropertyPartName: "Property part name",
    importPropertyPartCode: "Property part code",
    importLastAction: "Last action",
    importPreviewRows: "Showing {shown} of {total} rows.",
    importReadyRows: "{count} rows ready to import.",
    importSubmit: "Import",
    importBack: "Back",
    importMappingIncomplete:
      "Map all required columns: code, group name, property name, property part name, property part code, and description.",
    importDateParseError:
      "One or more last action values could not be parsed as dates.",
    importError:
      "Import failed. Check column mapping, numeric values, and date values.",
    importSuccess: "Imported {created} rows. Skipped {skipped} duplicates.",
    createGroup: "Create group",
    error: "Failed to save maintenance plan",
    groupError: "Failed to save group",
    codeError: "Failed to add code",
    confirmDeletePlan: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "maintenance plan",
      },
    ],
    confirmDeleteGroup: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "group",
      },
    ],
    groupDeleteError: "This group cannot be deleted because it is used by maintenance plans",
  },
  apartment: {
    apartment: sharedEn.apartment.apartment,
    apartments: sharedEn.apartment.apartments,
    index: "Index",
    objectNumber: "Object number",
    streetNumber: "Street number",
    apartmentNumber: "Apartment number",
    floorNumber: "Floor number",
    area: "Area",
    residents: ":resident.residents",
    primaryOwner: ":resident.primaryOwner",
    share: "Share",
    state: {
      state: "State",
      vacant: "Vacant",
      condo: "Condo",
      lease: "Tenancy",
      sublet: "Sublet",
    },
    subletTo: "Sublet to",
    viewHoldings: "View :holding.holdings[lowercase]",
    viewActiveHoldings: "View :holding.holdings[lowercase]",
    viewLeases: "View :lease.leases[lowercase]",
    viewActiveLeases: "View active :lease.leases[lowercase]",
    viewSublets: "View :sublet.sublets[lowercase]",
    viewActiveSublets: "View active :sublet.sublets[lowercase]",
    issueCount: "Issues",
    create: "Create apartment",
    error: "Failed to save apartment",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: ":apartment.apartment[lowercase]",
      },
    ],
  },
  person: {
    person: sharedEn.person.person,
    persons: sharedEn.person.persons,
    personalIdentificationNumber: "Personal identification number",
    personalIdentificationNumberAbbreviation: "SSN",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone",
    age: "Age",
    status: {
      status: "Status",
      none: "None",
      owner: "Owner",
      tenant: "Tenant",
      subtenant: "Subtenant",
    },
    currentApartment: "Current :apartment.apartment[lowercase]",
    issueCount: "Issues",
    error: "Failed to save person",
    create: "Create person",
  },
  organization: {
    organization: sharedEn.organization.organization,
    organizations: sharedEn.organization.organizations,
    corporateRegistrationNumber: "Corporate registration number",
    corporateRegistrationNumberAbbreviation: "EIN",
    name: "Name",
    email: "Email",
    phone: "Phone",
    status: {
      status: "Status",
      none: "None",
      owner: "Owner",
      tenant: "Tenant",
      subtenant: "Subtenant",
    },
    currentApartment: "Current :apartment.apartment[lowercase]",
    issueCount: "Issues",
    error: "Failed to save organization",
    create: "Create organization",
  },
  role: {
    role: sharedEn.role.role,
    roles: sharedEn.role.roles,
    name: "Name",
    description: "Description",
    externalDescription: "External description",
    contact: "Contact",
    assignedTo: "Assigned to",
    assignedToEmpty: "No members assigned",
    updatedBy: "Updated by",
    create: "Create role",
    error: "Failed to save role",
    confirmDelete: "Are you sure you want to delete this role?",
    deleteError: "Could not delete role",
  },
  user: {
    users: "Users",
    forAssociation: "Showing users for",
    email: "Email",
    firstName: ":person.firstName",
    lastName: ":person.lastName",
    type: "Type",
    active: "Active",
    create: "Create user",
    sendInvite: "Send invite email",
    password: "Password",
    passwordPlaceholderKeep: "Leave blank to keep current password",
    createError: "Failed to create user",
    editError: "Failed to update user",
    electedRepresentativeType: {
      label: "Elected position",
      none: "None",
      boardMember: "Board member",
      alternateBoardMember: "Alternate board member",
      representative: "Representative",
      other: "Other",
    },
  },
  holding: {
    holding: sharedEn.holding.holding,
    holdings: sharedEn.holding.holdings,
    owner: {
      owners: "Owners",
      primary: "Primary",
      share: "Share",
    },
    residents: ":resident.residents",
    fromDate: ":fromDate",
    toDate: ":toDate",
    contractLength: "Contract length",
    active: ":active",
    state: {
      state: "State",
      active: "Active",
      ended: "Ended",
      sublet: "Sublet",
    },
    subletTo: "Sublet to",
    viewApartment: [
      ":viewEntity",
      { entity: ":apartment.apartment[lowercase]" },
    ],
    issueCount: "Issues",
    create: "Create holding",
    error: "Failed to save holding",
  },
  lease: {
    lease: sharedEn.lease.lease,
    leases: sharedEn.lease.leases,
    residents: ":resident.residents",
    fromDate: ":fromDate",
    toDate: ":toDate",
    contractLength: "Contract length",
    active: ":active",
    state: {
      state: "State",
      active: "Active",
      ended: "Ended",
      sublet: "Sublet",
    },
    subletTo: "Sublet to",
    viewApartment: [
      ":viewEntity",
      { entity: ":apartment.apartment[lowercase]" },
    ],
    issueCount: "Issues",
    create: "Create lease",
    error: "Failed to save lease",
  },
  sublet: {
    sublet: sharedEn.sublet.sublet,
    sublets: sharedEn.sublet.sublets,
    residents: ":resident.residents",
    fromDate: ":fromDate",
    toDate: ":toDate",
    contractLength: "Contract length",
    active: ":active",
    viewApartment: [
      ":viewEntity",
      { entity: ":apartment.apartment[lowercase]" },
    ],
    issueCount: "Issues",
    create: "Create sublet",
    error: "Failed to save sublet",
  },
  boardMeeting: {
    boardMeeting: "Board meeting",
    boardMeetings: "Board meetings",
    create: "Create board meeting",
    edit: "Edit meeting details",
    name: "Name",
    date: "Date and time",
    location: "Location",
    locationEmpty: "No location set",
    caller: "Caller",
    called: "Called",
    calledHint: "Only called members can see the meeting once it has been called.",
    calledEmpty: "No one is called yet",
    attended: "Attended",
    attendedEmpty: "No attendance recorded",
    secretary: "Secretary",
    secretaryNone: "Not set",
    verifiers: "Verifiers",
    verifiersEmpty: "No verifiers set",
    state: "State",
    backToList: "Back to list",
    you: "you",
    error: "Failed to save board meeting",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: ":boardMeeting.boardMeeting[lowercase]",
      },
    ],
    states: {
      draft: "Draft",
      call: "Call",
      called: "Called",
      opened: "Opened",
      ongoing: "Ongoing",
      ended: "Ended",
      cleaning: "Cleaning",
      review: "Review",
      complete: "Complete",
    },
    stateDescriptions: {
      draft: "Prepare the agenda. Only statements can be written, and only you can see the meeting.",
      call: "Preview of the notice. Statements are locked. You can still go back to draft.",
      called: "The meeting has been called. Called members can now see it and comment.",
      opened: "Set the secretary and verifiers, and record who attended.",
      ongoing: "Write conclusions and decisions. Close each item when it is done.",
      ended: "The meeting has ended. What was noted is saved and can no longer change.",
      cleaning: "Clean up the minutes. Every item has to be closed again before review.",
      review: "Verifiers compare the notes with the cleaned minutes and confirm.",
      complete: "The minutes are complete and locked.",
    },
    moveTo: {
      call: "Ready to call",
      draft: "Back to draft",
      called: "Call meeting",
      opened: "Open meeting",
      ongoing: "Start meeting",
      ended: "End meeting",
      cleaning: "Start cleaning",
      review: "Send to review",
      complete: "Complete meeting",
    },
    backToCleaning: "Back to cleaning",
    confirmMoveTo: {
      called: "Call the meeting? It can no longer go back to draft.",
      ended: "End the meeting? It can't be reopened.",
      complete: "Complete the meeting? Everything will be locked for good.",
    },
    blocked: {
      BoardMeetingNoCalled: "Call at least one member first.",
      BoardMeetingNoContents: "Add at least one item to the agenda first.",
      BoardMeetingStatementsIncomplete: "Every item needs a statement first.",
      BoardMeetingSecretaryMissing: "Choose a secretary first.",
      BoardMeetingVerifiersMissing: "Choose at least one verifier first.",
      BoardMeetingSecretaryIsVerifier: "The secretary can't also be a verifier.",
      BoardMeetingContentsOpen: "Close every item first.",
      BoardMeetingConfirmationsMissing: "Every verifier has to confirm first.",
      BoardMeetingDecisionMissing: "Set the outcome of the decision first.",
    },
    waitingFor: {
      review: "Waiting for the secretary to send the minutes to review.",
      complete: "Waiting for the verifiers to confirm.",
    },
    readOnly: "You can view this meeting but can't change it in its current state.",
    agenda: "Agenda",
    preview: "Notice",
    previewIntro: "This is how the notice for the meeting will look.",
    sectionsEmpty: "The agenda is empty",
    sectionAdd: "Add section",
    sectionName: "Section name",
    sectionRename: "Rename",
    sectionConfirmDelete: "Delete this section and all of its items?",
    contentAdd: "Add item",
    contentType: "Type",
    contentTypes: {
      information: "Information",
      decision: "Decision",
    },
    contentsEmpty: "No items in this section",
    statement: "Statement",
    statementPlaceholder: "What the meeting needs to know or decide…",
    statementEmpty: "No statement written",
    conclusion: "Conclusion",
    conclusionInformation: "Discussion notes",
    conclusionPlaceholder: "What was concluded or discussed…",
    conclusionEmpty: "Nothing noted",
    decision: "Decision",
    decisions: {
      resolved: "Resolved",
      tabled: "Tabled",
      dismissed: "Dismissed",
    },
    decisionNone: "Not decided",
    contentStates: {
      open: "Open",
      closed: "Closed",
    },
    close: "Close",
    reopen: "Reopen",
    contentConfirmDelete: "Delete this item?",
    moveUp: "Move up",
    moveDown: "Move down",
    delete: "Delete",
    saving: "Saving…",
    notedDuringMeeting: "Noted during the meeting",
    cleanedMinutes: "Cleaned minutes",
    attachments: "Attachments",
    comments: "Comments",
    commentsCount: "Comments ({count})",
    commentsEmpty: "No comments yet",
    commentPlaceholder: "Write a comment…",
    commentAdd: "Add comment",
    commentDelete: "Delete",
    commentEdited: "edited",
    commentConfirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "comment",
      },
    ],
    people: "Participants",
    review: "Review",
    confirm: "Confirm minutes",
    revokeConfirmation: "Revoke confirmation",
    confirmedAt: "Confirmed {date}",
    notConfirmed: "Not confirmed",
    history: "History",
    createdAt: "Created",
  },
  procurement: {
    procurements: "Procurements",
    create: "Create procurement",
    title: "Title",
    description: "Description",
    descriptionEmpty: "—",
    tags: "Tags",
    tagsHint:
      "Type and press Enter to add. Suggestions come from tags on other procurements.",
    tagsPlaceholder: "Add a tag",
    state: "State",
    statePrevious: "Previous",
    stateNext: "Next",
    stateOpen: "Open",
    stateInReview: "In review",
    stateClosed: "Closed",
    stateCanceled: "Canceled",
    actionReadyForReview: "Ready for review",
    actionClose: "Close",
    actionCancel: "Cancel",
    actionReopen: "Reopen",
    winner: "Winner",
    winnerSelect: "Select winner",
    winnerSubmit: "Set winner and close",
    createContract: "Create contract",
    viewContract: "View contract",
    backToList: "Back to list",
    createdBy: "Created by",
    createdAt: "Created",
    updatedAt: "Updated",
    organizationsEmpty: "No organizations linked",
    organizationAdd: "Add",
    organizationRemove: "Remove",
    organizationPrice: "Price",
    organizationPriceEmpty: "No price",
    organizationFilesCount: "{count} files",
    files: "General files",
    filesGeneral: "Procurement (no organization)",
    filesAttachTo: "Attach to",
    lockedForReview:
      "This procurement is in review. Editing and file uploads are disabled until the state changes.",
    comments: "Comments",
    commentsEmpty: "No comments yet",
    commentPlaceholder: "Write a comment…",
    commentAdd: "Add comment",
    commentDelete: "Delete",
    commentEdited: "edited",
    commentConfirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "comment",
      },
    ],
    error: "Failed to save procurement",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: ":procurement.procurement[lowercase]",
      },
    ],
    procurement: "Procurement",
  },
  contract: {
    contract: "Contract",
    contracts: "Contracts",
    create: "Create contract",
    title: "Title",
    total: "Total",
    description: "Description",
    tags: "Tags",
    tagsHint:
      "Type and press Enter to add. Suggestions come from tags on other contracts.",
    tagsPlaceholder: "Add a tag",
    status: "Status",
    statusActive: "Active",
    statusInactive: "Inactive",
    cost: "Cost",
    invoiceType: "Cost per",
    invoiceTypeMonthly: "month",
    invoiceTypeQuarterly: "quarter",
    invoiceTypeSemiAnnually: "half year",
    invoiceTypeAnnually: "year",
    counterParty: "Counterparty",
    fromDate: "From",
    toDate: "To",
    files: "Contract files",
    summaryNav: "Summary",
    summaryTitle: "Contract summary",
    summaryIntro:
      "Active contracts only. Amounts are converted to a yearly total: monthly × 12, quarterly × 4, semi-annually × 2, annually × 1. If invoice period is not set, the entered amount is treated as one year’s total.",
    summaryActiveList: "Active contracts",
    summaryNoActive: "No active contracts.",
    summaryPerYear: "yr",
    summaryNoCost: "No cost",
    summaryTagBarsTitle: "Costs per tag (stacked by contract)",
    summaryTagBarsExplain:
      "X-axis is tags and Y-axis is annualized cost. Each stack segment is one contract, so totals per tag include all contracts that use that tag.",
    summaryTagBarsNoTags: "No tags with cost on active contracts.",
    summaryContractBarsTitle: "Costs per contract",
    summaryContractBarsExplain:
      "X-axis is contracts and Y-axis is annualized cost. One bar per contract.",
    summaryPieTitle: "Share of total annual cost",
    summaryPieExplain:
      "Each slice is one active contract’s annualized cost as a share of the total for all active contracts with a cost.",
    summaryPieEmpty: "No contract costs to chart.",
    summaryOther: "Other contracts",
    error: "Failed to save contract",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: ":contract.contract[lowercase]",
      },
    ],
  },
  issue: {
    issues: "Issues",
    board: "Board",
    issuesWithoutParent: "Issues without parent",
    boardCard: "card",
    boardCards: "cards",
    boardExpandLane: "Expand swimlane",
    boardCollapseLane: "Collapse swimlane",
    boardAddIssue: "Add issue to swimlane",
    stateDoneWontdo: "Done / Won't do",
    fastumTickets: "Fastum tickets",
    fastumSync: "Sync",
    fastumTicketId: "Ticket ID",
    fastumOpenExternal: "Open external ticket",
    fastumType: "Type",
    fastumClass: "Class",
    fastumActionAt: "Action at",
    fastumTicketsLinked: "Fastum tickets",
    fastumTicketsLinkedEmpty: "No Fastum tickets linked",
    fastumTicketAdd: "Add ticket",
    fastumTicketTarget: "Ticket",
    fastumTicketTargetPlaceholder: "Example: 12345 or search by title",
    fastumLinkedToIssue: "Linked to issue",
    create: "Create issue",
    createGroup: "Create group",
    identifier: "Issue no.",
    descriptionEmpty: "—",
    title: "Title",
    description: "Description",
    tags: "Tags",
    tagsHint:
      "Type and press Enter to add. Suggestions come from tags on other issues.",
    tagsPlaceholder: "Add a tag",
    type: "Type",
    typeGroup: "Group",
    typeIssue: "Issue",
    typeTask: "Task",
    parent: "Parent",
    parentEmpty: "No parent",
    state: "State",
    stateTodo: "To do",
    stateInProgress: "In progress",
    stateDone: "Done",
    stateWontdo: "Won't do",
    createdBy: "Created by",
    createdAt: "Created",
    updatedAt: "Updated",
    links: "Links",
    linksEmpty: "No links added",
    registers: "Records",
    registersEmpty: "No records added",
    recordType: "Record type",
    recordTarget: "Record",
    recordAdd: "Add record",
    linkRelation: "Relation",
    linkDirection: "Direction",
    linkDirectionIn: "Incoming",
    linkDirectionOut: "Outgoing",
    linkType: "Link type",
    linkTypeRelate: "Related",
    linkTypeBlock: "Block",
    linkTarget: "Issue",
    linkTargetManual: "Manual issue ID",
    linkTargetSelectPlaceholder: "Select issue",
    linkTargetManualPlaceholder: "Example: 1234",
    linkAdd: "Add link",
    linkRemove: "Remove",
    linkRelatedTo: "Related to",
    linkBlockedBy: "Blocked by",
    linkBlocks: "Blocks",
    linkSelf: "Issue cannot be linked to itself",
    linkDuplicate: "This link already exists",
    comments: "Comments",
    commentsEmpty: "No comments yet",
    commentPlaceholder: "Write a comment…",
    commentAdd: "Add comment",
    commentDelete: "Delete",
    commentEdited: "edited",
    commentError: "Failed to save comment",
    commentConfirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "comment",
      },
    ],
    error: "Failed to save issue",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "issue",
      },
    ],
  },
  overview: {
    overview: "Overview",
    residentType: "Resident type",
    residentTypeHolding: ":holding.holding",
    residentTypeLease: ":lease.lease",
    residentTypeSublet: ":sublet.sublet",
    ownershipShare: "Ownership share",
    resident: "Resident",
    email: ":person.email",
    phone: ":person.phone",
    identificationNumber: "ID number",
    age: ":person.age",
    contractLength: ":holding.contractLength",
    viewApartment: [":viewEntity", { entity: ":apartment.apartment[lowercase]" }],
    viewHolding: [":viewEntity", { entity: ":holding.holding[lowercase]" }],
    viewLease: [":viewEntity", { entity: ":lease.lease[lowercase]" }],
    viewSublet: [":viewEntity", { entity: ":sublet.sublet[lowercase]" }],
  },
  resident: {
    resident: "Resident",
    residents: "Residents",
    primaryOwner: "Primary owner",
  },
  tenant: {
    tenant: "Tenant",
    tenants: "Tenants",
  },
  subtenant: {
    subtenant: "Subtenant",
    subtenants: "Subtenants",
  },
  profile: {
    title: "Profile",
    email: "Email",
    currentPassword: "Current password",
    updatePassword: "Update password",
    password: "Password",
    repeatPassword: "Repeat Password",
    submit: "Update",
    sender: "Sender",
    incorrectOldPassword: "Incorrect old password",
  },
  footer: {
    organizationNumber: "Org.no",
    contact: "Contact",
    email: "Email",
    phone: "Phone",
    followUs: "Follow us",
  },
  action: {
    action: "Action",
    actions: "Actions",
    delete: "delete",
  },
  viewEntity: "View {entity}",
  yes: "Yes",
  no: "No",
  ok: "OK",
  cancel: "Cancel",
  close: "Close",
  fullscreen: {
    enter: "Fullscreen",
    exit: "Exit fullscreen",
  },
  select: {
    placeholder: "Select an option",
  },
  confirm: {
    delete: "Are you sure you want to {action} this {entity}?",
  },
  fromDate: "From",
  toDate: "To",
  customName: "Custom name",
  useCustomName: "Use custom name",
  defaultName: "Default name",
  active: "Active",
  status: "Status",
  year: "year",
  years: "years",
  month: "month",
  months: "months",
  empty: "No data available",
  error: {
    code: {
      title: "Server responded with error",
      message: "The following error occurred: {error}",
    },
    ApartmentNotFound: {
      title: ":apartment.apartment not found",
      message: "The :apartment.apartment[lowercase] not found",
    },
    ApartmentHasHoldingsOrLeases: {
      title:
        ":apartment.apartment has :holding.holdings[lowercase] or :lease.leases[lowercase]",
      message:
        "This :apartment.apartment has :holding.holdings[lowercase] or :lease.leases[lowercase]. Please remove them before deleting the :apartment.apartment[lowercase]",
    },
    ApartmentIndexAlreadyExists: {
      title: ":apartment.apartment index already exists",
      message:
        "The :apartment.apartment[lowercase] index already exists. Please choose a different index",
    },
    MaintenancePlanGroupHasMaintenancePlans: {
      title: "Group is used by maintenance plans",
      message:
        "Remove or reassign maintenance plans that use codes in this group before deleting it.",
    },
    MaintenancePlanCodeHasMaintenancePlans: {
      title: "Code is used by maintenance plans",
      message:
        "Remove or reassign maintenance plans that use this code before deleting it.",
    },
    MaintenancePlanCodeAlreadyExists: {
      title: "Code already exists in this group",
      message: "Choose a different code for this group.",
    },
    PropertyHasMaintenancePlans: {
      title: "Property is used by maintenance plans",
      message:
        "Remove maintenance plans that use property parts on this property before deleting it.",
    },
    PropertyPartHasMaintenancePlans: {
      title: "Property part is used by maintenance plans",
      message:
        "Remove maintenance plans that use this property part before deleting it.",
    },
    PropertyCodeAlreadyExists: {
      title: "Property code already exists",
      message: "Choose a different property code.",
    },
  },
};
